import React, { useState, useEffect } from 'react';
import Footer from '../Footer';

const PastEvents = () => {
  const [message, setMessage] = useState("Soon Uploading Past Events");

  useEffect(() => {
    const interval = setInterval(() => {
      setMessage((prevMessage) =>
        prevMessage === "Soon Uploading Past Events" ? "Stay Tuned, Coming Soon!" : "Soon Uploading Past Events"
      );
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh', // Full viewport height
      }}
    >
      {/* Main content */}
      <div style={{ flex: 1, textAlign: 'center', marginTop: '50px' }}>
        <h2 style={{ fontSize: '1.5rem', marginBottom: '20px' }}>{message}</h2>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default PastEvents;
